import { Theme } from '@mui/material';


export const gray = {
  light05: '#FAFAFA',
  light10: '#EBEDEC',
  light20: '#D9DDDB',
  light30: '#B5BDB9',
  light60: '#67726D',
  light80: '#474E4B',

  main: '#22271D',
  light: '#FAFAFA',
  dark: '#22271D',
  contrastText: 'white'
} as const;

export const favoriteColor = {
  light05: '#FFF9E6',
  light80: '#FFC700',
  light: '#FFF9E6',
  main: '#F2AE00',
  darker120: '#DD8500',
  dark: '#DD8500',
  contrastText: 'white'
} as const;

export const primaryColor = {
  light05: '#F2FCF8',
  light60: '#CBF1E2',
  light80: '#A3E2C9',
  darker110: '#04B776',
  darker120: '#00AA6D',
  darker140: '#0B9865',
  darker180: '#1A5D45',
  darker200: '#1E3E30',
  main: '#02C37E',
  light: '#F2FCF8',
  dark: '#009761',
  darker: '#0B9865',
  contrastText: 'white'
} as const;

export const secondaryColor = {
  main: '#FFF',
  light: '#FFF',
  dark: '#FFF',
  contrastText: ''
} as const;

const background = {
  default: gray.light10,
  paper: '#FFF'
} as const;

export const successColor = {
  light: '#F2FCF8',
  main: '#009761',
  dark: '#14AE5C',
  contrastText: '#009761'
} as const;

export const errorColor = {
  light80: '#EF4563',
  light: '#FEF4F4',
  main: '#DE1344',
  dark: '',
  contrastText: '#F2FCF8'
} as const;

export const infoColor = {
  light: '#E6EFF2',
  main: '#005978',
  dark: '',
  contrastText: ''
} as const;

export const palette: Partial<Theme['palette']> = {
  background: {
    ...background
  },
  favorite: {
    ...favoriteColor
  },
  primary: {
    ...primaryColor
  },
  gray: {
    ...gray
  },
  secondary: {
    ...secondaryColor
  },
  success: {
    ...successColor
  },
  warning: {
    contrastText: '',
    dark: '#EE8F00',
    light: '#FEFBF4',
    main: '#F2AE00'

  },
  error: {
    ...errorColor
  },
  info: {
    ...infoColor
  }
} as const;
